import {
  Button, Col, Modal, Row, Form, Input, Radio
} from 'antd';
import React, {useState} from "react";
import { useTranslation } from "react-i18next";
import './Maintenance.css';
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";

const { TextArea } = Input;


const ReviewJobTask = ({vehicle, isViewReviewRequestModalVisible, selectedReviewRequest, setSelectedReviewRequest, 
                        taskBeingReviewed, setIsViewReviewRequestModalVisible, form, jobItemStatuses}) => {
  
  const { t } = useTranslation();
  const { isOnline } = useOnlineStatus();
  const [ loadingProgress ] = useState(0);  //start 0 - button shows loading if less than 100
  const [showMandatoryNoteField, setShowMandatoryNoteField] = useState(false);


  function handleOutcome(taskBeingReviewed, response) 
  {
    setShowMandatoryNoteField(false);
    if (response === 'REJECT')
    {
      setShowMandatoryNoteField(true);
    }
  }

  const onFinish = (values) => {
    const driverApproved = 'DRIVER_APPROVED';
    const driverRejected = 'DRIVER_REJECTED';

    const newJobReviewed = {
      ...selectedReviewRequest
    }

        newJobReviewed.items.forEach(element => {
      if (element.id === taskBeingReviewed.id)
      {
        element.status = values.reviewOutcome === 'APPROVE' ? driverApproved : driverRejected;
        element.reviewNote = values.note;
        element.reviewOutcome = values.reviewOutcome;
      }
    });

    setSelectedReviewRequest(newJobReviewed);
    setIsViewReviewRequestModalVisible(false); 
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Form Failed:', errorInfo);
  };

  const NoteField = ({showMandatoryNoteField, reviewItem}) => {
      return (
            (showMandatoryNoteField)
            ?
            <Row style={{ marginTop: '10px' }}>
              <Col xs={24} sm={24} md={24}>
                <Form.Item name="note" 
                           label={t('field.note')} 
                           labelCol={{span: 24}}
                           rules={[
                          { required: true, message: t('error.no_value_named', {0: t('field.note')})},
                      () => ({
                          validator(_, value) {
                              if (!value) {
                                  return Promise.reject();
                              }
                              return Promise.resolve();
                          },
                      }),
                  ]}
                     >
            <TextArea placeholder={t('action.enter_value')}
                      rows={4}
                      maxLength={2000}
                      showCount
            />
          </Form.Item>
        </Col>
      </Row>
      :
      <Row style={{ marginTop: '10px' }}>
        <Col xs={24} sm={24} md={24}>
          <Form.Item name="note" 
                     label={t('field.note')} 
                     labelCol={{span: 24}}>
            <TextArea placeholder={t('action.enter_value')}
                      rows={4}
                      maxLength={2000}
                      showCount
            />
          </Form.Item>
        </Col>
      </Row>    
           )
  }
  
  const ReviewOutcome = (props) => {
    return (
             <div>
               <Row style={{width:'100%'}} >
                 <Col>
                   <Form.Item name={'reviewOutcome'} 
                              style={{ fontSize: '20px' }}
                              label={ t('field.review_outcome')}
                              rules={[
                                { required: true, message: t('error.no_value_named', {0: t('field.review_outcome')})},
                                ]}
                   >
                      <Radio.Group 
                        options={[{value:'APPROVE', key:'APPROVE', label: t('action.approve')}, 
                                  {value:'REJECT', key:'REJECT', label: t('action.reject')}]}
                        optionType="button"
                        buttonStyle="solid"
                        onSelect={props.onSelect}
                        onChange={(e) => {
                            props.handleOutcome(props.reviewItem, e.target.value);
                        }}
                      >
                      </Radio.Group>   
                   </Form.Item>
                 </Col>
               </Row>
             </div>
           );
  }
  
return (
         <Modal className="std-portal-popup dp-wrap-card-title" 
                open={isViewReviewRequestModalVisible && selectedReviewRequest}
                title={ t('title.review_for', {0: [taskBeingReviewed ? taskBeingReviewed.description : ""]})}
                closable={true}
                keyboard={true}
                footer={
                         isOnline
                         ?
                         [
                          <Button key="cancel" 
                                  onClick={(e) => {
                                    setIsViewReviewRequestModalVisible(false); 
                                    form.resetFields();
                                  }}
                          >
                            {t('action.cancel')}
                          </Button>,
                          <Button type="primary" 
                                  form="taskreview"
                                  loading={loadingProgress !== 100 && !vehicle} 
                                  key="submit"
                                  htmlType="submit"
                          >
                            {t('action.save')}
                          </Button>
                        ]
                        :
                        <></>
                        }
                onCancel={() => {
                  setIsViewReviewRequestModalVisible(false);
                }}
         >
          <Form form={form} 
                layout="horizontal" 
                id="taskreview"
                name="taskreview" 
                style={{"width": "100%"}} 
                onFinish={onFinish}  
                onFinishFailed={onFinishFailed}
          >
            <ReviewOutcome reviewItem={taskBeingReviewed} 
                           form={form} 
                           handleOutcome={handleOutcome}
            />
            <NoteField showMandatoryNoteField={showMandatoryNoteField}
                       reviewItem={taskBeingReviewed}
            >  
            </NoteField>
          </Form>
         </Modal>     
       );
}

export default ReviewJobTask;